<template>
  <b-overlay :show="loading">
    <Search
      :title="title"
      :url="url"
      :allowFields="$lang.userParvandehListFields"
      :visibleAdd="false"
      :showFilterBtn="false"
      :visibleSettings="false"
      :visibleExport="false"
      :dataNotExist="$lang.notRecordExist"
      :dynamicButtons="buttons"
      :operationField="$lang.operation"
    />
  </b-overlay>
</template>
<script>
import Search from "@/components/base/search";
import { pathOr } from "ramda";

export default {
  components: {
    Search,
  },
  props: {
    userItem: {
      type: Object,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      buttons: [
        {
          id: "0",
          name: "edit",
          iconFont: "far fa-check-circle fa-lg text-success",
          text: this.$lang.definition_change_role,
          click: this.setCurrentParvandeh,
        },
        {
          id: "0",
          name: "edit",
          iconFont: "fas fa-history fa-lg text-success",
          text: this.$lang.show_change_role,
          click: this.showChangeRole,
        },
      ],
    };
  },
  computed: {
    title() {
      const fullName =
        pathOr("", ["person", "name"], this.userItem) +
        pathOr("", ["person", "family"], this.userItem);
      return this.$lang.userParvandehListTitle.replace("{0}", fullName);
    },
    url() {
      const code = pathOr(null, ["code"], this.userItem);
      return (
        this.$config.api_url +
        this.$config.profile.user_parvandeh.replace("{0}", code)
      );
    },
  },
  methods: {
    setCurrentParvandeh(item) {
      this.$emit("updateCurrentParvandeh", item, false);
    },
    showChangeRole(item) {
      this.$emit("updateCurrentParvandeh", item, true);
    },
  },
};
</script>